import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["basename", "fontDir", "fileBase", "formats"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var fontWeights = {
  thin: 100,
  extraLight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900
};
export var fontStyles = {
  normal: 'normal',
  italic: 'italic',
  oblique: 'oblique'
};
export var defineFont = function defineFont(font) {
  var _font$fallback;
  return {
    fontFamily: "\"".concat(font.fontFamily, "\", ").concat((_font$fallback = font.fallback) !== null && _font$fallback !== void 0 ? _font$fallback : 'sans-serif'),
    fontWeight: (font == null ? void 0 : font.fontWeight) || fontWeights.regular,
    fontStyle: (font == null ? void 0 : font.fontStyle) || fontStyles.normal
  };
};
var defaultFormats = [{
  ext: 'woff2',
  format: 'woff2'
}, {
  ext: 'woff',
  format: 'woff'
}];
export var declareFont = function declareFont(_ref) {
  var basename = _ref.basename,
    fontDir = _ref.fontDir,
    fileBase = _ref.fileBase,
    formats = _ref.formats,
    params = _objectWithoutProperties(_ref, _excluded);
  var dir = fontDir !== null && fontDir !== void 0 ? fontDir : basename;
  var file = fileBase !== null && fileBase !== void 0 ? fileBase : basename;
  var basePath = "/fonts/".concat(dir, "/").concat(file);
  var fmtList = formats !== null && formats !== void 0 ? formats : defaultFormats;
  var urlParts = fmtList.map(function (_ref2) {
    var ext = _ref2.ext,
      format = _ref2.format;
    return "url(\"".concat(basePath, ".").concat(ext, "\") format(\"").concat(format, "\")");
  });
  var src = formats != null ? urlParts : ["local(".concat(basename, ")")].concat(_toConsumableArray(urlParts));
  return _objectSpread(_objectSpread({}, params), {}, {
    fontDisplay: 'swap',
    src: src
  });
};